import { useEffect } from "react";

const NotFound = () => {
  // Static hosting can't return a real HTTP 404, so signal noindex to Googlebot
  // (which executes JS) — this is what deindexes the URL.
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, follow";
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <div
      className="flex items-center justify-center w-full h-96 bg-white pt-32"
      style={{ transform: "translateY(-10%)" }}
    >
      <h2 className="text-6xl">404 Error - Page Not Found</h2>
    </div>
  );
};

export default NotFound;
